import React from "react";


import styled from "styled-components";
import { componentHeights, Styles } from "../config";
import store from "../store";

const _getPadding = ({ init, padding }) => {
  if (init) return `${componentHeights.nav} 0 0 0`;
  else if (padding) return padding;
  else return "0";
};


const Vessel = styled.section`
  position: relative;
  display: flex;
  flex-direction: ${(props) => (props.$column ? "column" : "row")};
  align-items: ${(props) => props.$align || "center"};
  flex-wrap: ${(props) => (props.$nowrap ? "nowrap" : "wrap")};
  justify-content: ${(props) => props.$justify || "center"};
  min-height: ${(props) =>
    props.$init
      ? `calc( 100vh - ${props.$isPublicRoute ? '180px' : componentHeights.footer} - ${componentHeights.nav})`
      : "100vh"};
  width: ${(props) => props.$width || "100%"};
  max-width: ${(props) => (props.$hasMaxWidth ? "1600px" : "100%")};
  overflow-x: ${(props) => props.$overflow || "hidden"};
  padding: ${(props) =>
    _getPadding({ padding: props.$padding, init: props.$init }) || "0!important"};
  margin: ${(props) => props.$margin || "0!important"};
  flex-wrap: nowrap;
`;

const Background = styled.div`
  width: ${(props) => props.width || "100%"};
  min-height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  background: ${(props) =>
    props.background
      ? Styles.Color[props.background]
      : Styles.Color.background};
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;


`;



const WindoW = (props) => {


  const { background, width, style } = props;

  return (
    <Vessel
      $column={Boolean(props.column)}
      $align={props.align}
      $nowrap={props.nowrap}
      $init={props.init}
      $justify={props.justify}
      $width={props.width}
      $hasMaxWidth={props.hasMaxWidth}
      $overflow={props.overflow}
      $padding={props.padding}
      $margin={props.margin}
      $isPublicRoute={store.browser.currentRouteObject?.isPublic}
    >
      <Background
        width={width}
        background={background}
        style={style}
      ></Background>
      {props.children}
    </Vessel>
  );
};



export default WindoW
